import { db } from '@/shared/db/database';
import type { IAccessRoleRepository } from '../../domain/repositories/IAccessRoleRepository';
import type { AccessRole } from '../../domain/entities/AccessRole';
import type { AccessRoleDTO } from '../dto/AccessRoleDTO';
import { toAccessRole } from '../mappers/accessRoleMapper';

export class LocalAccessRoleRepository implements IAccessRoleRepository {
  async listAll(): Promise<AccessRole[]> {
    const rows = await db.accessRoles.toArray();
    return rows.map((row) => toAccessRole(row.raw as AccessRoleDTO));
  }

  async upsertAll(_roles: AccessRole[], rawDtos: AccessRoleDTO[]): Promise<void> {
    const items = rawDtos.map((dto) => ({ idAccessRole: dto.id_access_role, raw: dto }));
    await db.accessRoles.bulkPut(items);
  }
}
